import React from 'react'

export const StagePlanAsync = React.lazy(() => import('./stage-plan'))
